
import { Product } from "@/types/product";

export const vpxTC1LT: Product = {
  id: "vpx-tc1-lt",
  groupId: "avoip",
  name: "VPX-TC1-LT",
  subtitle: "1Gb Box Transceiver",
  description: "The VPX-TC1-LT is the low-cost version of the VPX-TC1-PRO utilizing the same Aurora Mimix™ CODEC technology. Mimix™ compression allows for near perfect reproduction of video and graphic images at resolutions up to 4K30 4:4:4 over 1G networks. It has zero frame (1.78ms) of latency and seamless switching for fast lag free content. Power consumption is important as the VPX-TC1-LT uses as little as 6.4 watts. It does this with no fan and a small form factor saving a lot of money in utility bills as it uses 1/3 the power of comparable systems.\n\nAudio, video, data, and control can be sent securely to one or many units using off-the-shelf 1G RJ-45 Ethernet switch. When the VPX-TC1-LT is set up to be a transmitter, the HDMI input becomes the source, and the HDMI output becomes a loop out.\n\nWhen set up as a receiver, a user can select the local HDMI input or an IP streaming source. Seamless switching of the sources further enhances the presentation. Regardless of how the VPX-TC1-LT is set up, the audio can be de-embedded at any location, and/or be sent to or received from a Dante® enabled device.\n\nThe USB is also flexible, working as a KVM and/or a high-speed data transfer for memory sticks & another port just for cameras. To keep the system friendly, an OSD and integrated web server are available for easy navigation and setup of features. The VPX LT model is fully compatible with the VPX PRO models.\n\nDigital signage, education, corporate, and residential are just a few markets which benefit from the flexibility and low cost of the VPX-TC1-LT.",
  features: [
    "Configure as Encoder or Decoder",
    "4K30 4:4:4/4K60- 4:2:0 UHD 120m over 1G CAT 5e",
    "Zero Frame Latency (1.78ms)",
    "HDMI 2.0b, HDCP 2.2",
    "LPCM up to 8-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Low Power Fanless Design",
    "Scaling & Seamless Switching",
    "MJPEG Preview 480p 15 frames",
    "Video Wall with Image Rotation",
    "1G LAN PoE and SFP for Fiber or 2nd RJ-45",
    "1 HDMI Inputs, 1 HDMI Output",
    "Line In/Out Stereo",
    "RS-232 Serial Port and IR (In/Out)",
    "Channel Mapping with OSD",
    "Integrated Web Server for Configuration",
    "USB 2.0 Ports for Cameras, HID, Mass Storage, etc.",
    "AES67 Inlcuded",
    "Dante® 2 Ch Audio License Option",
    "Rack and Under Table Mounting"
  ],
  specifications: [
    "Compression: Mimix™ 13:1",
    "Latency: 0 Frame (1.78ms) with Ultra Low Latency Mode",
    "HDMI Inputs: 1 (HDMI 2.0b, HDCP 2.2)",
    "HDMI Outputs: 1 (HDMI 2.0b, HDCP 2.2)",
    "Encryption: AES 256",
    "Audio Analog: Stereo Line In/Out (3.5mm TRS)",
    "1G Ethernet: RJ-45 and SFP",
    "LAN: RJ-45 10/100/1000M PoE",
    "Video Bandwidth: 300MHz",
    "Video Support: Up to 4K2K 4:4:4 @ 30Hz",
    "Audio Support: Up to 12 Channels",
    "Video Stream Bandwidth: 10Mbps – 800Mbps (4K30 4:4:4)",
    "USB Bandwidth: 200Mbps (Camera/HID/Mass Storage Devices)",
    "RS-232: Up to 115k Baud (3.5mm TRS)",
    "IR: Bi-Directional (3.5mm TRS)",
    "USB Connector: 1 USB 2.0 Type C (Host), 2 USB 2.0 Type A (Devices)",
    "Options: Dante® 2Ch License",
    "Interface: IR or Keyboard via OSD, Web Server",
    "Housing: Black Aluminum Enclosure",
    "Dimensions (L x W x H): 177.04 x 150.7 x 26.42mm [6.97\" x 5.93\" x 1.04\"]",
    "Weight: 13.8oz [390g]",
    "Mounting: Optional: Rack Mount Vertical, Rack Mount Horizontal, Under Table Mount",
    "Power Supply: 48v DC (2 Pin Euro) or PoE (LAN)",
    "Power Consumption: 6 Watts, up to 12.9 Watts with USB",
    "Operation Temperature: 0~40o C [32~104o F]",
    "Storage Temperature: -20~60o C [-4~140o F]",
    "Relative Humidity: 20~90% RH [No Condensation]",
    "Package Contents: 1x VPX-TC1-LT, 2x Mounting Ears"
  ],
  images: [
    "/lovable-uploads/610c48a8-6fff-4498-beac-1d9a91b38375.png",
    "/lovable-uploads/fecf8c19-3cf1-4f5a-a43b-22f7311060d3.png",
    "/lovable-uploads/e296664d-b2be-41bd-bba8-7f9efe4198f2.png"
  ],
  videoUrl: "https://youtu.be/dAolV2vTp9c?si=KpcEs38V7Kl8rVVe",
  applicationDiagram: "/lovable-uploads/VPX-TC1-LT_Application_Diagram.png",
  slug: "vpx-tc1-lt",
  networkSpeed: "1gb"
};
